module.exports = __webpack_public_path__ + "static/21972-312_SOC_NonCPA-66933e610a8fce7fdb0e0c5a51be0194.png";